import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogTitle } from '../../components/ui/dialog';
import { api, errMsg } from '../api';
import { goldBtn, inputCls } from '../ui';
import { PERMISSION_SECTIONS } from '../shells/nav';

const FLAGS = [['purchase', 'Può acquistare servizi a pagamento', 'report, visure, controlli: scalano dal plafond aziendale'], ['topup', 'Può richiedere ricariche del plafond', 'le richieste arrivano a te per l\'approvazione']];

export default function MemberForm({ member, onClose, onSaved }) {
  const p = member?.permissions || {};
  const [f, setF] = useState({ email: member?.email || '', name: member?.name || '', sections: p.sections || [], purchase: !!p.purchase, topup: !!p.topup,
    capOn: member?.cap_cents != null, cap: member?.cap_cents != null ? member.cap_cents / 100 : 200, active: member ? member.active : true });
  const [busy, setBusy] = useState(false);
  const toggle = (id) => setF({ ...f, sections: f.sections.includes(id) ? f.sections.filter((s) => s !== id) : [...f.sections, id] });
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = { name: f.name, active: f.active, permissions: { sections: f.sections, purchase: f.purchase, topup: f.topup }, cap_eur: f.capOn ? Number(f.cap) : null };
    try {
      if (member) await api.put(`/team/${member.id}`, body); else await api.post('/team', { ...body, email: f.email });
      toast.success(member ? 'Permessi aggiornati' : 'Invito inviato');
      onSaved();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="design-dialog max-w-xl max-h-[92vh] overflow-y-auto" data-testid="member-form">
        <DialogTitle className="font-heading text-xl">{member ? `Permessi di ${member.name || member.email}` : 'Invita un utente'}</DialogTitle>
        <form onSubmit={save} className="space-y-4">
          <div className="grid sm:grid-cols-2 gap-3">
            <input required minLength={2} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Nome e cognome" className={`${inputCls} border px-3`} data-testid="member-name" />
            <input required type="email" disabled={!!member} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="Email aziendale" className={`${inputCls} border px-3 disabled:opacity-60`} data-testid="member-email" />
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.18em] opacity-70 mb-2">Sezioni visibili</p>
            <div className="grid grid-cols-2 gap-2">
              {PERMISSION_SECTIONS.map(({ id, label, icon: Icon }) => (
                <label key={id} className={`flex items-center gap-2 px-3 py-2 border rounded-sm text-sm cursor-pointer transition-colors ${f.sections.includes(id) ? 'border-[#D4AF37] bg-[#D4AF37]/10' : 'border-[#1F242C]'}`} data-testid={`member-section-${id}`}>
                  <input type="checkbox" checked={f.sections.includes(id)} onChange={() => toggle(id)} className="accent-[#D4AF37]" /><Icon size={14} />{label}
                </label>
              ))}
            </div>
          </div>
          {FLAGS.map(([k, l, d]) => (
            <label key={k} className="flex items-start gap-3 text-sm cursor-pointer" data-testid={`member-flag-${k}`}>
              <input type="checkbox" checked={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.checked })} className="mt-1 accent-[#D4AF37]" />
              <span><span className="font-semibold">{l}</span><span className="block text-xs opacity-70">{d}</span></span>
            </label>
          ))}
          <div className="flex flex-wrap items-center gap-3 text-sm">
            <label className="flex items-center gap-2 cursor-pointer" data-testid="member-cap-toggle"><input type="checkbox" checked={f.capOn} onChange={(e) => setF({ ...f, capOn: e.target.checked })} className="accent-[#D4AF37]" />Tetto di spesa mensile</label>
            {f.capOn && <span className="flex items-center gap-2"><input type="number" min={0} step="1" value={f.cap} onChange={(e) => setF({ ...f, cap: e.target.value })} className={`${inputCls} border px-3 w-28 font-mono`} data-testid="member-cap" />€ al mese</span>}
          </div>
          {member && <label className="flex items-center gap-2 text-sm cursor-pointer" data-testid="member-active"><input type="checkbox" checked={f.active} onChange={(e) => setF({ ...f, active: e.target.checked })} className="accent-[#D4AF37]" />Accesso attivo</label>}
          <button disabled={busy} className={`${goldBtn} h-11 px-6 text-sm inline-flex items-center gap-2`} data-testid="member-save">{busy && <Loader2 size={15} className="animate-spin" />}{member ? 'Salva permessi' : 'Invia invito'}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
